import e from "../managers/braze-instance.js";
export function subscribeToSdkAuthenticationFailures(r) {
  if (e.rr()) return e.ii().subscribeToSdkAuthenticationFailures(r);
}
